import { displayFontFamily, headerFontFamily } from "styles/theme";

const styles = {
  hero: {
    position: "relative",
    borderRadius: "24px",
    p: { xs: "40px 22px", md: "56px 48px 50px" },
    textAlign: "center",
    mb: "24px",
    overflow: "hidden",
    backgroundImage:
      'linear-gradient(170deg, rgba(1,67,57,0.88) 0%, rgba(1,50,43,0.94) 48%, rgba(1,32,27,0.99) 100%), url("https://storage.googleapis.com/hatchways-crm.appspot.com/app-assets/b2go.avif")',
    backgroundSize: "cover",
    backgroundPosition: "center 15%",
  },
  eyebrow: {
    fontFamily: headerFontFamily,
    fontSize: "12px",
    letterSpacing: ".14em",
    textTransform: "uppercase",
    color: "#B1B3F8",
    mb: "18px",
  },
  title: {
    fontFamily: displayFontFamily,
    fontWeight: 600,
    fontSize: { xs: "33px", md: "48px" },
    lineHeight: 1.05,
    color: "#ffffff",
    m: "0 auto 18px",
    maxWidth: "580px",
  },
  subtitle: {
    fontSize: { xs: "15px", md: "16.5px" },
    lineHeight: 1.55,
    color: "#cdded7",
    maxWidth: "470px",
    m: "0 auto 34px",
  },
  countdownLabel: {
    fontFamily: headerFontFamily,
    fontSize: "11.5px",
    letterSpacing: ".12em",
    textTransform: "uppercase",
    color: "#9fc3b7",
    mb: "14px",
  },
  countdownRow: {
    display: "flex",
    justifyContent: "center",
    gap: { xs: "8px", md: "10px" },
  },
  countdownBox: {
    minWidth: { xs: 0, md: "66px" },
    flex: { xs: "1 1 0", md: "0 0 auto" },
    p: { xs: "11px 4px", md: "12px 8px" },
    backgroundColor: "rgba(255,255,255,.08)",
    border: "1px solid rgba(255,255,255,.16)",
    borderRadius: "12px",
  },
  countdownValue: {
    fontFamily: displayFontFamily,
    fontWeight: 600,
    fontSize: "32px",
    lineHeight: 1,
    color: "#F7EE6F",
  },
  countdownUnit: {
    fontFamily: headerFontFamily,
    fontSize: "9.5px",
    letterSpacing: ".12em",
    textTransform: "uppercase",
    color: "#9fc3b7",
    mt: "7px",
  },
  closedPill: {
    display: "inline-flex",
    alignItems: "center",
    gap: 1.125,
    p: "12px 22px",
    backgroundColor: "rgba(255,255,255,.06)",
    border: "1px solid rgba(255,255,255,.16)",
    borderRadius: "999px",
    fontFamily: headerFontFamily,
    fontSize: "14px",
    color: "#f7f6f0",
  },
};

export default styles;
